import fetch from '@/api/fetch.js'
import { reg } from './config'

const DOMAIN_NAME = `https://client.winbaoxian.${reg ? 'com' : 'cn'}`
const _fetch = (config = {}) => {
  return fetch({
    baseURL: DOMAIN_NAME,
    ...config,
  }).then(response => {
    const { data, success, code, info } = response.data;
    if (!success) {
      return Promise.reject(new Error(`${code}: ${info}`));
    }
    return data
  })
}

export function addVisitorReadEvent(params) {
  return _fetch({
    url: '/visitorReadEventStatistic/addReadEvent',
    method: 'POST',
    data: params
  })
}